let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8qkPR")).then(() => parcelRequire('dci17'));